<footer class="footer">
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6">
                {{year}} © FASEYA PRO.
            </div>
            <div hidden class="col-sm-6">
                <div class="text-sm-end d-none d-sm-block">
                    Design & Develop by Faseya
                </div>
            </div>
        </div>
    </div>
</footer>
